module.exports = __webpack_public_path__ + "static/img/fsxbH5.bb96edc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fsxbH5.png
// module id = 13S8
// module chunks = 0